import { useRef } from 'react';

// ─────────────────────────────────────────────────────────────
// Always holds the latest value of `val` without triggering
// effects. Replaces the useRef + useEffect sync boilerplate.
// ─────────────────────────────────────────────────────────────
const useLatestRef = (val) => {
  const ref = useRef(val);
  ref.current = val;
  return ref;
};

export default useLatestRef;